import * as types from '../actionTypes';

export const get = (pageNumber=null) =>{
  return{
    type: types.PETTY_CASHIER_VAT_REVIEW_REQUEST,
    pageNumber
  }
};

export const getSuccess = data => {
  return {
    type: types.PETTY_CASHIER_VAT_REVIEW_SUCCESS,
    payLoad: data
  };
};
export const getFailure = (error) => {
  return {
    type: types.PETTY_CASHIER_VAT_REVIEW_FAILURE,
    error: error
  };
};